import {
  CREATE_SESSION_REQUEST,
  CREATE_SESSION_SUCCESS,
  CREATE_SESSION_FAILURE,
  UPDATE_SESSION_REQUEST,
  UPDATE_SESSION_SUCCESS,
  UPDATE_SESSION_FAILURE,
  DELETE_SESSION_REQUEST,
  DELETE_SESSION_SUCCESS,
  DELETE_SESSION_FAILURE,
  FETCH_SESSION_REQUEST,
  FETCH_SESSION_SUCCESS,
  FETCH_SESSION_FAILURE
} from '../actions/sessions';

const sessions = (state = [], action) => {
  switch (action.type) {
    case CREATE_SESSION_REQUEST:
      return {
        ...state,
        error: false
      };
    case CREATE_SESSION_SUCCESS:
      return {
        ...state,
        user: action.user,
        error: false
      };
    case CREATE_SESSION_FAILURE:
      return {
        ...state,
        error: true
      };
    case UPDATE_SESSION_REQUEST:
      return {
        ...state,
        error: false
      };
    case UPDATE_SESSION_SUCCESS:
      return {
        ...state,
        user: action.user,
        error: false
      };
    case UPDATE_SESSION_FAILURE:
      return {
        ...state,
        error: true
      };
    case DELETE_SESSION_REQUEST:
      return {
        ...state,
        error: false
      };
    case DELETE_SESSION_SUCCESS:
      return {
        ...state,
        user: undefined,
        error: false
      };
    case DELETE_SESSION_FAILURE:
      return {
        ...state,
        error: true
      };
    case FETCH_SESSION_REQUEST:
      return {
        ...state,
        error: false
      };
    case FETCH_SESSION_SUCCESS:
      return {
        ...state,
        user: action.user,
        error: false
      };
    case FETCH_SESSION_FAILURE:
      return {
        ...state,
        user: undefined,
        error: true
      };
    default:
      return state;
  }
};

export default sessions;



// WEBPACK FOOTER //
// ./src/reducers/sessions.js